export default "__VITE_ASSET__dKyYL7ek__";